var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-9",attrs:{"id":"main"}},[_c('ProfileHeader',{attrs:{"psychic":_vm.psychic}}),_c('LoginHistory',{attrs:{"id":this.$route.params['id']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }